export default __webpack_public_path__ + "static/media/TIENLEN_HISTORY_WEB-ENG.59c10c2a.jpg";